import {
  Alert,
  Breadcrumbs,
  Button,
  Chip,
  CircularProgress,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";
import { instance } from "../../Const/ApiHeader";
import { ADD_RUNNING_TEXT, GET_RUNNING_TEXT } from "../../Const/ApiConst";

function formatDate(value) {
  if (!value) return "-";
  let date;
  const id = String(value);
  if (id.length === 24 && /^[a-f0-9]+$/i.test(id)) {
    date = new Date(parseInt(id.substring(0, 8), 16) * 1000);
  } else {
    date = new Date(value);
  }
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function RunningText() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [text, setText] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState("");

  const loadRunningText = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await instance.get(GET_RUNNING_TEXT);
      setItems(response.data || []);
    } catch (err) {
      console.log(err);
      setError("Failed to load running text.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRunningText();
  }, []);

  const handleClose = () => {
    if (!saveLoading) {
      setShowModal(false);
      setText("");
      setError("");
    }
  };

  const handleAdd = async () => {
    const value = text.trim();
    if (!value) {
      setError("Running text cannot be empty.");
      return;
    }

    setSaveLoading(true);
    setError("");
    try {
      await instance.post(ADD_RUNNING_TEXT, { text: value });
      setText("");
      setShowModal(false);
      await loadRunningText();
    } catch (err) {
      console.log(err);
      setError("Failed to save running text. Please try again.");
    } finally {
      setSaveLoading(false);
    }
  };

  const activeItem = items[0];

  return (
    <div className="vehicles-page">
      <Breadcrumbs aria-label="breadcrumb" className="mb-3">
        <Link to="/">Home</Link>
        <Typography>Running Text</Typography>
      </Breadcrumbs>

      <section className="vehicles-hero">
        <div>
          <Typography className="vehicles-hero-eyebrow">App banner</Typography>
          <Typography variant="h4" className="vehicles-hero-title">
            Running Text
          </Typography>
          <Typography className="vehicles-hero-subtitle">
            Manage the scrolling message shown on the mobile app home screen.
          </Typography>
        </div>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setShowModal(true)}>
          Add
        </Button>
      </section>

      {error && !showModal ? (
        <Alert severity="error" className="mt-3">
          {error}
        </Alert>
      ) : null}

      <section className="section running-text-active">
        <Typography className="vf-section-title">Currently live in app</Typography>
        {loading ? (
          <div className="running-text-loading">
            <CircularProgress size={28} />
          </div>
        ) : activeItem ? (
          <div className="running-text-live-card">
            <Chip size="small" label="Live" color="success" />
            <Typography className="running-text-live-value">
              {activeItem.runningText}
            </Typography>
            <Typography className="running-text-live-meta">
              Added {formatDate(activeItem._id)}
            </Typography>
          </div>
        ) : (
          <Typography color="text.secondary">
            No running text yet. Add one to display it in the app.
          </Typography>
        )}
      </section>

      <section className="section">
        <Typography className="vf-section-title mb-3">History</Typography>
        {loading ? (
          <Typography color="text.secondary">Loading...</Typography>
        ) : items.length === 0 ? (
          <Typography color="text.secondary">No entries yet.</Typography>
        ) : (
          <table className="table admin-table mb-0">
            <thead>
              <tr>
                <th>Text</th>
                <th>Status</th>
                <th>Added</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={item._id}>
                  <td>{item.runningText}</td>
                  <td>
                    {index === 0 ? (
                      <Chip size="small" label="Live" color="success" />
                    ) : (
                      <Chip size="small" label="Archived" />
                    )}
                  </td>
                  <td>{formatDate(item._id)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add running text</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Form.Group>
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Enter the text to show in the app banner..."
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </Form.Group>
          <Typography variant="caption" color="text.secondary" className="mt-2 d-block">
            The newest entry is shown in the mobile app.
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={saveLoading}>
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            loading={saveLoading}
            onClick={handleAdd}
          >
            Save
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default RunningText;
